import {ParamValue} from "~/dto/ParamValue.js";

export class Param {

    id;
    name;
    selectable = false;
    /**
     *
     * @type {ParamValue[]}
     */
    values = [];

    static createFromObj(obj) {
        const param = new Param(obj.paramId, obj.name);
        param.selectable = obj.selectable;
        param.values = obj.values.map(el => new ParamValue(el.value, el.variants));

        return param;
    }

    constructor(id, name) {
        this.id = id;
        this.name = name;
    }

    /**
     *
     * @param variantId
     * @return {ParamValue}
     */
    getVariantValue(variantId) {
        return this.values.find(el => el.variants.includes(variantId));
    }

    toString() {
        return this.values.map(el => el.value).join(", ");
    }

}